import { z } from 'zod';

// TODO: Oh, do we really want to make this a dependency?
// import type { Component } from 'vue'
const OpenApiExtensionSchema = z.object({
    /**
     * Name of specification extension property. Has to start with `x-`.
     *
     * @example
     * ```yaml
     * x-custom-extension: foobar
     * ```
     */
    name: z.string().regex(/^x-/),
    /**
     * Vue component to render the OpenAPI extension
     */
    component: z.unknown(),
});
const ApiReferencePluginSchema = z.function().returns(z.object({
    name: z.string(),
    extensions: z.array(OpenApiExtensionSchema),
}));

export { ApiReferencePluginSchema, OpenApiExtensionSchema };
